import {allowedTypes} from "../../schemas/attachments/attachmentsSchema";

export const isFileTypeAllowed = (type: string): boolean => {
    return allowedTypes.some(allowed => {
        if (allowed.endsWith('/*')) {
            const baseType = allowed.split('/')[0];
            return type.startsWith(`${baseType}/`);
        }
        return type === allowed;
    });
};